export enum Roles {
  ADMIN = 'admin',
  MANAGER = 'manager',
  MEMBER = 'member',
  OWNER = 'owner',
}

// ? Roles within any team
export enum TeamRoles {
  MANAGER = 'teamManager',
  CURRENT_USER = 'currentUser',
}
